import { createFileRoute, redirect } from '@tanstack/react-router';

import { useNavState } from '@/lib/nav-state';
import { CampaignDetailScreen } from '@/screens/attribution/CampaignDetailScreen';

/** The row comes from history state (entity), not the URL; without it, back to the list. */
export const Route = createFileRoute('/_app/attribution/detail')({
  beforeLoad: ({ location }) => {
    if (!location.state.entity) throw redirect({ to: '/attribution', replace: true });
  },
  component: DetailRoute,
});

function DetailRoute() {
  const { entity } = useNavState();
  if (!entity) return null;
  return <CampaignDetailScreen key={`${entity.kind}:${entity.id}`} level={entity.kind} id={entity.id} />;
}
